import { useAppConfig } from "../context/AppConfig/AppConfigContext";
import { useDevMode } from "../context/DevMode";
import { useEnvContext } from "../context/EnvironmentContext";
import { hasMosCfg } from "../utils/urlParams";

export type AbTestValue = number | null | undefined;

interface GetAbTestValueParams {
    // shouldUseAbTestFlag: boolean | null | undefined;
    isProduction: boolean;
    abTestVariant: AbTestValue;
    devModeVariant: number | null;
    hasMosUtmConfig: boolean;
}

const getAbTestValue = ({
    // shouldUseAbTestFlag,
    isProduction,
    abTestVariant,
    devModeVariant,
    hasMosUtmConfig,
}: GetAbTestValueParams): AbTestValue => {
    const defaultAbValue = isProduction ? abTestVariant : devModeVariant;

    if (hasMosUtmConfig) return 1;
    // if (!shouldUseAbTestFlag) return 1;

    return defaultAbValue;
};

export const useAbTestValue = (): AbTestValue => {
    const { isProduction } = useEnvContext();
    const { devModeVariant } = useDevMode();

    // TODO: Remove NewH US-only AB eligibility after the experiment is finished. (shouldUseAbTestFlag)
    // const { abTestVariant, shouldUseAbTestFlag } = useAppConfig();
    const { abTestVariant } = useAppConfig();

    const hasMosUtmConfig = hasMosCfg();

    return getAbTestValue({
        // shouldUseAbTestFlag,
        isProduction,
        abTestVariant,
        devModeVariant,
        hasMosUtmConfig,
    });
};
